import React, { useEffect, useState, useRef } from "react";
import HomePageNavBar from "../Components/HomePageNavBar";
import LocationBar from "../Components/LocationBar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../Components/Footer";
import PrivacyPolicyPopup from "./PrivacyPolicyPopup";
import ListingsCard from "../Components/ListingsCard";
import ListingsFeed from "../Components/ListingsFeed";
import { hiddenCategories } from "../Constants/hiddenCategories";

import { getPreferredListings, getListings } from "../Services/listingsApi";
import { getCities } from "../Services/citiesApi";
import { getCategory } from "../Services/CategoryApi";
import { getCurrentUser } from "../Services/usersApi";

import CITYIMAGE from "../assets/City.png";
import CITYDEFAULTIMAGE from "../assets/CityDefault.png";
import MostPopularCategories from "../Components/MostPopularCategories";
import AllCategoriesTiles from "../Components/AllCategoriesTiles";
import AllServicesTiles from "../Components/AllServicesTiles";

function ListingsAndTilesSkeleton() {
    return (
      <div className="animate-pulse">
        {/* Header skeleton */}
        <div className="flex justify-between items-center px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10">
          <div className="h-8 bg-gray-200 rounded w-48"></div>
          <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
        </div>
  
        {/* Listings grid skeleton */}
        <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 flex flex-col space-y-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="flex flex-col space-y-3 rounded-lg border border-gray-200 p-4"
              >
                <div className="w-full h-48 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              </div>
            ))}
          </div>
          <div className="flex justify-center mt-10">
            <div className="h-10 w-40 bg-gray-200 rounded-full"></div>
          </div>
        </div>
  
        {/* Discover More title */}
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10">
          <div className="h-8 bg-gray-200 rounded w-64"></div>
        </div>
  
        {/* Discover More carousel */}
        <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 flex space-x-4 overflow-x-auto">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="h-80 w-80 bg-gray-200 rounded-2xl flex-shrink-0"
            ></div>
          ))}
        </div>
  
        {/* All Categories title */}
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10">
          <div className="h-8 bg-gray-200 rounded w-48"></div>
        </div>
  
        {/* All Categories tiles */}
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-40 bg-gray-200 rounded"></div>
          ))}
        </div>
  
        {/* All Services title */}
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-10">
          <div className="h-8 bg-gray-200 rounded w-48"></div>
        </div>
  
        {/* All Services tiles */}
        <div className="px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="h-40 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

const HomePageTerminal = () => {
    const { t } = useTranslation();
    const [cityId, setCityId] = useState([]);
    const [categoryId, setCategoryId] = useState();
    const [cities, setCities] = useState([]);
    const [listings, setListings] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [categories, setCategories] = useState([]);
    const [services, setServices] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [terminalView, setTerminalView] = useState(false);
    const [isGridView, setIsGridView] = useState(true);
    const queryParams = new URLSearchParams(location.search);
    const terminalViewParam = queryParams.get("terminalView");

    const isTerminalScreenEnvEnabled =
        process.env.REACT_APP_ENABLE_TERMINALSCREEN === "True";

    const isTerminalScreenEnabled = isTerminalScreenEnvEnabled && terminalViewParam === "true";

    const toggleView = () => {
        setIsGridView((prev) => !prev);
    };

    const navigate = useNavigate();
    const navigateTo = (path) => {
        if (path) {
            navigate(path);
        }
    };

    function goBack() {
        navigateTo(`/`);
    }

    const getCategoryNameById = (id) => {
        const catObj = categories.find((c) => c.id === id);
        return catObj ? catObj.name : "";
    };

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    useEffect(() => {
        let timer;
        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                window.location.reload();
            }, 5 * 60 * 1000); // 5 minutes
        };
        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
        events.forEach((event) => {
            window.addEventListener(event, resetTimer);
        });
        resetTimer();
        return () => {
            clearTimeout(timer);
            events.forEach((event) => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, []);

    useEffect(() => {
        const checkPrivacyPolicy = async () => {
            const hasAcceptedGlobally = getCookie("privacyPolicyAcceptedGlobally");

            if (hasAcceptedGlobally === "true") {
                setShowPopup(false);
            }
        };

        checkPrivacyPolicy();
    }, []);

    const hardcodedServices = [
        {
            id: 1,
            name: "Heidi Tourismus",
            url: "https://www.jungfrau.ch",
            image: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=800&q=80",
        },
        {
            id: 2,
            name: "Swiss Travel Pass",
            url: "https://www.jungfrau.ch",
            image: "https://plus.unsplash.com/premium_photo-1689977092774-8febf6e5edc8?q=80&w=2129&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        },
        {
            id: 3,
            name: "My Switzerland",
            url: "https://www.jungfrau.ch",
            image: "https://plus.unsplash.com/premium_photo-1674297229805-e8a1877f9ca4?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        },
        {
            id: 4,
            name: "Heidi's Village",
            url: "https://www.jungfrau.ch",
            image: "https://images.unsplash.com/photo-1506461883276-594a12b11cf3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fGluZGlhfGVufDB8fDB8fHww",
        },
        {
            id: 5,
            name: "Zurich Tourism",
            url: "https://www.jungfrau.ch",
            image: "https://images.unsplash.com/photo-1659389952410-59fc1f039d27?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8WnVyaWNofGVufDB8fDB8fHww",
        },
        {
            id: 6,
            name: "Geneva Travel",
            url: "https://www.jungfrau.ch",
            image: "https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8VHJhdmVsfGVufDB8fDB8fHww",
        },
        {
            id: 7,
            name: "Jungfrau Railways",
            url: "https://www.jungfrau.ch",
            image: "https://images.unsplash.com/photo-1701153014005-f6c90be06408?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fEp1bmdmcmF1JTIwUmFpbHdheXxlbnwwfHwwfHx8MA%3D%3D",
        },
        {
            id: 8,
            name: "Matterhorn Paradise",
            url: "https://www.matterhornparadise.ch",
            image: "https://plus.unsplash.com/premium_photo-1697729968500-d0c63fd49bfa?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bWFuaGF0dGVufGVufDB8fDB8fHww",
        },
    ];

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        setTerminalView(isTerminalScreenEnabled);

        getCities()
            .then((citiesResponse) => {
                if (Array.isArray(citiesResponse?.data?.data)) {
                    setCities(citiesResponse.data.data);
                } else {
                    setCities([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching cities:", error);
                setCities([]);
            });

        const cityParam = parseInt(queryParams.get("cityId"));
        if (cityParam) {
            setCityId(cityParam);
        }
        const catParam = parseInt(queryParams.get("categoryId"));
        if (catParam) {
            setCategoryId(catParam);
        }

        getCategory()
            .then((response) => {
                const allCats = response?.data?.data || [];
                const filteredCats = allCats.filter((cat) => !hiddenCategories.includes(cat.id));
                setCategories(filteredCats);
            })
            .catch((err) => {
                console.error("Error fetching categories:", err);
                setCategories([]);
            });

        setServices(hardcodedServices);
        document.title = process.env.REACT_APP_REGION_NAME;
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        if (parseInt(categoryId)) {
            urlParams.set("categoryId", categoryId);
        } else {
            urlParams.delete("categoryId");
        }

        const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
        window.history.pushState({}, "", newUrl);

        fetchData();
    }, [cityId, categoryId, searchQuery]);

    const fetchData = async (locationParams = {}) => {
        try {
            setIsLoading(true);

            const accessToken =
                window.localStorage.getItem("accessToken") ||
                window.sessionStorage.getItem("accessToken");

            let userId =
                window.localStorage.getItem("userId") ||
                window.sessionStorage.getItem("userId");

            if (!userId && accessToken) {
                try {
                    const res = await getCurrentUser();
                    userId = res?.data?.id;
                    if (userId) {
                        localStorage.setItem("userId", userId);
                    }
                } catch (error) {
                    console.warn("User fetch failed, using public listings instead.");
                }
            }

            const params = {
                pageSize: 12,
                statusId: 1,
                pageNo: 1,
                ...locationParams,
            };

            const normalizedCityId = Array.isArray(cityId) ? cityId : [cityId];
            if (normalizedCityId[0]) {
                params.cityIds = normalizedCityId.join(",");
            }

            if (categoryId) {
                params.categoryIds = String(categoryId);
            }

            if (searchQuery.trim().length > 0) {
                params.searchQuery = searchQuery.trim();
            }

            let response;

            if (userId) {
                response = await getPreferredListings(userId, params);
            } else {
                response = await getListings(params);
            }

            setListings(response.data?.data || []);
        } catch (error) {
            console.error("Error fetching listings:", error);
            setListings([]);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    };

    const clearSearchResults = () => {
        setListings([]);
        setSearchQuery("");
    };

    const getTheListings = (newCategoryId, event) => {
        event.preventDefault();
        setCategoryId(newCategoryId);
        clearSearchResults();
    };

    const handleSearch = (searchTerm) => {
        setSearchQuery(searchTerm);
    };

    window.scrollTo(0, sessionStorage.getItem("scrollPosition") || 0);
    window.addEventListener("beforeunload", () => {
        sessionStorage.setItem("scrollPosition", window.scrollY);
    });

    const getCategoryImage = (catId) => {
        const catObj = categories.find((c) => c.id === catId);
        return catObj?.metadata?.logo || CITYIMAGE;
    };

    const scrollContainer = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const updateScrollability = () => {
            const width = window.innerWidth;
            let threshold = 4;

            if (width < 768) {
                threshold = 2; // small
            } else if (width >= 768 && width < 1024) {
                threshold = 3; // medium
            }

            setIsScrollable(cities.length >= threshold);
        };

        updateScrollability();

        window.addEventListener("resize", updateScrollability);
        return () => window.removeEventListener("resize", updateScrollability);
    }, [cities]);

    const scrollLeft = () => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollBy({ left: -300, behavior: "smooth" });
        }
    };

    const scrollRight = () => {
        if (scrollContainer.current) {
            scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
        }
    };

    // ADD Display is Inactive for 3 min STARTS
    const [showAdModal, setShowAdModal] = useState(false);
    const adModalRef = useRef(showAdModal);
    const modalContentRef = useRef();

    useEffect(() => {
        adModalRef.current = showAdModal;
    }, [showAdModal]);

    useEffect(() => {
        let inactivityTimer;

        const showAds = () => {
            setShowAdModal(true);
        };

        const resetTimer = (event) => {
            clearTimeout(inactivityTimer);
            if (
                showAdModal &&
                modalContentRef.current &&
                modalContentRef.current.contains(event.target)
            ) {
                return;
            }
            inactivityTimer = setTimeout(showAds, 3 * 60 * 1000); // 3 minute for testing
        };

        const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

        events.forEach((event) => window.addEventListener(event, resetTimer));

        resetTimer();

        return () => {
            clearTimeout(inactivityTimer);
            events.forEach((event) => window.removeEventListener(event, resetTimer));
        };
    }, []);
    // ADD Display is Inactive for 3 min ENDS

    return (
        <>
            <section className="text-gray-900 body-font relative">
                <HomePageNavBar />

                {showPopup && <PrivacyPolicyPopup />}

                <div className="container-fluid py-0 mr-0 ml-0 mt-0 w-full flex flex-col relative">
                    <div className="w-full mr-0 ml-0">
                        <div className="h-[40rem] lg:h-full overflow-hidden px-0 py-0 relative">
                            <div className="relative h-[40rem]">
                                <img
                                    alt="ecommerce"
                                    className="object-cover object-center h-full w-full"
                                    src={getCategoryImage(categoryId)}
                                    loading="lazy"
                                />

                                <div className="absolute inset-0 flex flex-col gap-4 items-center justify-center bg-gray-800 bg-opacity-75 text-white z--1">
                                    <div className="flex flex-col xl:flex-row md:items-center justify-between gap-4 mt-4 px-5 md:px-10 lg:px-[10rem] 2xl:px-[20rem]">
                                        <h1
                                            className="font-sans mb-8 lg:mb-12 text-4xl md:text-5xl lg:text-5xl font-bold tracking-wide"
                                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                                        >
                                            {t("homePageHeading")}
                                        </h1>

                                        <div className="mb-8 lg:mb-12 w-full">
                                            <LocationBar onSearch={handleSearch} searchQuery={searchQuery} refreshListings={fetchData} terminalView={terminalView} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Category tabs */}
                    <div className="absolute bottom-0 left-0 right-0">
                        <MostPopularCategories
                            categories={categories}
                            t={t}
                            getTheListings={getTheListings}
                        />
                    </div>
                </div>

                {isLoading ? (
                    <ListingsAndTilesSkeleton />
                ) : (
                    <>
                        <div
                            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold flex justify-between items-center"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                            <h2>
                                {categoryId
                                    ? t(getCategoryNameById(categoryId))
                                    : t("allCategories")}
                            </h2>

                            {/* Toggle view (grid vs feed) */}
                            <svg
                                className="h-6 w-6 fill-current text-gray-900 cursor-pointer"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                onClick={toggleView}
                            >
                                <path d="M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm32-192l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z" />
                            </svg>
                        </div>

                        {listings && listings.length > 0 ? (
                            <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-0 space-y-10 flex flex-col">
                                {isGridView ? (
                                    <div className="relative place-items-center bg-white mb-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 justify-start">
                                        {listings.map((listing, index) => (
                                            <ListingsCard
                                                listing={listing}
                                                terminalView={terminalView}
                                                key={index}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="columns-1 md:columns-2 gap-4">
                                        {listings.map((listing, index) => (
                                            <div
                                                key={index}
                                                className={`break-inside-avoid ${index % 2 === 1 ? "mt-6" : ""}`}
                                            >
                                                <ListingsFeed listing={listing} terminalView={terminalView} />
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <button
                                    className="mt-10 px-6 py-3 bg-gray-700 w-80 text-white rounded-full hover:scale-105 transition mx-auto"
                                    onClick={() => {
                                        if (!terminalView) {
                                            localStorage.setItem("selectedItem", t("chooseOneCategory"));
                                        }
                                        const url = terminalView
                                            ? "/AllListings?terminalView=true"
                                            : "/AllListings";
                                        navigateTo(url);
                                    }}
                                >
                                    {t("viewMore")}
                                </button>
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center min-h-[40vh] px-6">
                                <h2 className="mb-6 text-4xl font-bold">
                                    {t("currently_no_listings")}
                                </h2>
                                <p className="text-lg text-gray-600">
                                    {t("selectOtherCityorCategory")}
                                </p>
                                <button
                                    onClick={goBack}
                                    className="mt-10 px-6 py-3 bg-gray-700 text-white rounded-full hover:scale-105 transition"
                                >
                                    {t("goBack")}
                                </button>
                            </div>
                        )}

                        <h2
                            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                            {t("discoverMorePlaces")}
                        </h2>

                        <div className="bg-white px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 mt-0 mb-0 space-y-10 flex flex-col items-center">
                            <div className="flex items-center w-full relative">
                                {isScrollable && (
                                    <button
                                        onClick={scrollLeft}
                                        className="absolute hidden md:flex left-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                                    >
                                        ❮
                                    </button>
                                )}

                                <div
                                    ref={scrollContainer}
                                    className="flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth w-full"
                                    style={{ scrollSnapType: "x mandatory", whiteSpace: "nowrap" }}
                                >
                                    {cities.map((city) => {
                                        if (city.id !== Number(cityId)) {
                                            return (
                                                <div
                                                    key={city.id}
                                                    onClick={() => {
                                                        const scrollPosition = window.scrollY;
                                                        localStorage.setItem("selectedCity", city.name);
                                                        navigateTo(`/AllListings?cityId=${city.id}`);
                                                        window.addEventListener("popstate", function () {
                                                            window.scrollTo(0, scrollPosition);
                                                        });
                                                    }}
                                                    className="h-80 w-80 rounded-2xl cursor-pointer transition-transform duration-500 shadow-[0_3px_10px_rgb(0,0,0,0.2)] hover:scale-90 flex-shrink-0"
                                                    style={{ scrollSnapAlign: "start" }}
                                                >
                                                    <div className="relative h-80 rounded-2xl overflow-hidden">
                                                        <img
                                                            alt="ecommerce"
                                                            className="object-cover object-center rounded-lg h-full w-full"
                                                            src={
                                                                city.image
                                                                    ? city.image
                                                                    : CITYIMAGE
                                                            }
                                                            onError={(e) => {
                                                                e.target.src = CITYDEFAULTIMAGE;
                                                            }}
                                                        />
                                                        <div
                                                            className="absolute inset-0 flex flex-col justify-end text-white"
                                                            style={{
                                                                background:
                                                                    "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                                                            }}
                                                        >
                                                            <h1
                                                                className="text-xl pb-5 md:text-3xl font-sans font-bold mb-0 ml-4"
                                                                style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                                                            >
                                                                {city.name}
                                                            </h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}
                                </div>

                                {isScrollable && (
                                    <button
                                        onClick={scrollRight}
                                        className="absolute hidden md:flex right-0 z-10 p-2 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg bg-gray-900 border-4 border-white"
                                    >
                                        ❯
                                    </button>
                                )}
                            </div>
                        </div>

                        <h2
                            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                            {t("allCategories")}
                        </h2>

                        <div >
                            <AllCategoriesTiles
                                categories={categories}
                                t={t}
                            />
                        </div>

                        <h2
                            className="text-gray-900 px-5 md:px-10 lg:px-[5rem] xl:px-[10rem] 2xl:px-[20rem] py-6 text-xl md:text-3xl mt-10 lg:text-3xl title-font text-start font-sans font-bold"
                            style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                        >
                            {t("allServices")}
                        </h2>

                        <div >
                            <AllServicesTiles
                                services={services}
                                t={t}
                            />
                        </div>
                    </>
                )}

                {
                    !isLoading && (
                        <div className="bottom-0 w-full">
                            <Footer />
                        </div>
                    )
                }
            </section >

            {showAdModal && (
                <div className="fixed top-0 left-0 w-full h-full bg-black/20 backdrop-blur-sm flex items-center justify-center z-[99999]">
                    <div className="bg-white p-4 rounded-lg shadow-lg w-3/4 h-3/4 flex flex-col" ref={modalContentRef}>
                        <button
                            className="bg-white rounded-md p-2 inline-flex items-center justify-end text-red-600"
                            onClick={() => setShowAdModal(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <iframe
                            loading="lazy"
                            src="https://static.hamburg.de/kartenclient/prod/"
                            allow="geolocation"
                            className="w-full h-full"
                            title="Service Popup"
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default HomePageTerminal;